/**
 * @function genErrorInfo
 * @function validate
 */
export default {
    genErrorInfo: function(formCount) {
        var errorInfo = [];
        for (var i=0 ; i<formCount ; i++) {
            errorInfo.push({
                isValid: true,
                msg: '',
            });
        }
        return errorInfo;
    },
    validate: function(errorInfo) {
        for (var i of errorInfo) {
            if (!i.isValid) {
                return false;
            }
        }
        return true;
    },
};
